/*
 * FarmSteady — single-review auto-rotate controller.
 *
 * - Auto-advances the active review every section.dataset.rotateSeconds (default 7s)
 * - Pauses when the user hovers the section or focuses any dot
 * - Manual dot clicks jump to a specific review and reset the timer
 * - Honors prefers-reduced-motion: stays on first review, no rotation
 * - 0 in rotate_seconds disables auto-rotate (manual only)
 */
(function () {
  'use strict';

  function init(section) {
    const reviews = Array.from(section.querySelectorAll('[data-fs-review-index]'));
    const dots = Array.from(section.querySelectorAll('[data-fs-reviews-dot]'));
    if (reviews.length <= 1) return;

    const rotateSeconds = parseInt(section.dataset.rotateSeconds || '7', 10);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    let activeIndex = 0;

    // Expose duration to CSS so the progress fill matches
    section.style.setProperty('--fs-rotate-duration', rotateSeconds + 's');

    function setActive(index) {
      activeIndex = index;
      reviews.forEach((r, i) => {
        const isActive = i === index;
        r.classList.toggle('is-active', isActive);
        r.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      dots.forEach((d, i) => {
        const isActive = i === index;
        d.classList.toggle('is-active', isActive);
        d.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function advance() {
      setActive((activeIndex + 1) % reviews.length);
    }

    function startTimer() {
      if (rotateSeconds <= 0 || reducedMotion) return;
      stopTimer();
      timer = setInterval(advance, rotateSeconds * 1000);
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Manual dot click — jump + reset timer
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        setActive(i);
        startTimer();
      });
    });

    // Pause on hover (visual progress paused via CSS data-paused; timer
    // paused via clearInterval)
    section.addEventListener('mouseenter', () => {
      section.dataset.paused = 'true';
      stopTimer();
    });
    section.addEventListener('mouseleave', () => {
      section.dataset.paused = 'false';
      startTimer();
    });

    // Pause on keyboard focus inside the section
    section.addEventListener('focusin', () => {
      section.dataset.paused = 'true';
      stopTimer();
    });
    section.addEventListener('focusout', (e) => {
      if (!section.contains(e.relatedTarget)) {
        section.dataset.paused = 'false';
        startTimer();
      }
    });

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopTimer();
      } else {
        startTimer();
      }
    });

    startTimer();
  }

  function bootstrap() {
    document.querySelectorAll('[data-fs-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
